// extracted by mini-css-extract-plugin
module.exports = {"SOUND_ID":"sound"};